import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function TrendDownIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52174 4.00049L9.05953 10.5236L12.0425 7.54065L19.9996 16.4931V13.9983H21.9996V19.9983H15.9996V17.9983H18.6616L11.9568 10.4548L8.93928 13.4723L1.99707 5.29485L3.52174 4.00049Z",
    fill: "currentColor"
  }));
}